<template>
    <div class="notice-more-wrap">
        <div class="more-wrap">
            <div class="top-logo">
                <img :src="loginT"/>
            </div>
            <div class="top-bg">
                <img src="../../../assets/more_bg.png" />
                <div class="input-box">
                    <h3>{{title}}</h3>
                     <el-input placeholder="请输入要查询的内容" style="width:600px" v-model="keyword">
                        <el-button type="primary" slot="append" @click="searcch">搜索</el-button>
                    </el-input>
                </div>
            </div>
            <div class="list-box">
                 <div class="purchase_tab" v-if="pageType == 'purchase' && isLogin">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="询价中" name="0"></el-tab-pane>
                        <el-tab-pane label="已完结" name="1"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="table-box" v-if="pageType == 'company'">
                    <el-table :data="tableData" stripe size="mini" style="width: 100%" @row-click="rowClick">
                        <el-table-column prop="noticeType" label="公告类型" :formatter="formatType"></el-table-column>
                        <el-table-column prop="title" label="公告标题" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userName" label="发布人"></el-table-column>
                        <el-table-column prop="createTime" label="发布日期" style="width:120px"></el-table-column>
                    </el-table>
                </div>
                <div class="table-box" v-if="pageType == 'tender'">
                    <el-table :data="tableData" stripe size="mini" style="width: 100%" @row-click="rowClick">
                        <el-table-column prop="orderTitle" label="中标项目" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="buyerUnitName" label="采购企业"></el-table-column>
                        <el-table-column prop="createTime" label="发布时间" style="width:120px"></el-table-column>
                    </el-table>
                </div>
                <div class="table-box" v-if="pageType == 'purchase'">
                    <el-table :data="tableData" stripe size="mini" style="width: 100%" @row-click="rowClick">
                        <el-table-column prop="title" label="寻源项目" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="buyerUnitName" label="采购企业"></el-table-column>
                        <el-table-column prop="createTime" label="发布时间" style="width:120px"></el-table-column>
                    </el-table>
                </div>
                <div class="show-more-notice" v-if="count>0">
                    <pagination  @on-pagination="onPagination" :page.sync="page"
                                :limit.sync="limit"
                                :total="count">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginT from '../../../assets/login_logo1.png';
import { getNoticeList,winBidNoticeList ,sourcNoticeList} from '../../../api/notice';
import { noticeType } from '../../../utils/dict'
import { getToken } from '@/utils/app'
export default {
    data() {
        return {
            loginT,
            pageType:'',
            keyword:'',
            title:'',
            page:1,
            limit:20,
            count:0,
            tableData:[],
            activeName:'0',
            isLogin:getToken()
        };
    },
    created() {
        console.log(this.$route)
        this.pageType = this.$route.params.type;
        this.searcch()
    },
    methods: {
        searcch(){
            this.page = 1;
            this.allGetList();
        },
        onPagination: function (val) {
            this.page = val.page;
            this.limit = val.limit;
            this.allGetList();
        },
        allGetList(){
            if(this.pageType == 'company'){  // 企业公告
                this.title = '企业公告';
                this.getCompanyList()
            }
            if(this.pageType == 'tender'){  // 中标公告
                this.title = '中标公告';
                this.getTenderList()
            }
            if(this.pageType == 'purchase'){  // 采购寻源
                this.title = '采购寻源';
                this.getPurchaseList()
            }
        },
        // 获取企业公告
        async getCompanyList(){
            let _this = this;
            let quertInfo= {
                page: this.page, //当前页码
                limit: this.limit, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    keyWord: this.keyword||'',
                    status:'1',
                    noticeType:'',
                }
            };
            if(!this.isLogin){
                quertInfo.objMap['publicHomePage'] = '是'
            };
            _this.loading = true;
            const { data: res } = await getNoticeList(quertInfo)
            _this.loading = false;
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.count = res.count;
            }
        },
        async getTenderList(){
            // 获取中标公告立碑
            let _this = this;
            let quertInfo= {
                page: this.page, //当前页码
                limit: this.limit, //当前每页显示的数量
                objMap: {
                    keyWord: this.keyword||'',
                }
            };
            _this.loading = true;
            const { data: res } = await winBidNoticeList(quertInfo);
            if(res.code == 0){
                _this.tableData = res.data || [];
                _this.count = res.count;
            }

        },
        async getPurchaseList(){
            let _this = this;
            let quertInfo= {
                page: this.page, //当前页码
                limit: this.limit, //当前每页显示的数量
                objMap: {
                    keyWord: this.keyword||'',
                    status:this.activeName
                }
            };
            _this.loading = true;
            const { data: res } = await sourcNoticeList(quertInfo);
            if(res.code == 0){
                _this.tableData = res.data || [];
                _this.count = res.count;
            }
        },
        // 点击行
        rowClick(row){
            let origin = window.location.origin+window.location.pathname;
            if(this.pageType == 'company'){
                window.open(`/noticeinfo/${row.id}`)
            }
            if(this.pageType == 'tender'){
              if(this.checkRole('cgy_role') || this.checkRole('leader') || this.checkRole('pw') || this.checkRole('gys_role')){
                    window.open(`/tendernoticeinfo/${row.id}`)
                }else{
                    this.$warn('请通过审核后查看！')
                }

            }
             if(this.pageType == 'purchase'){
               if(this.checkRole('cgy_role') || this.checkRole('leader') || this.checkRole('pw') || this.checkRole('gys_role')){
                    window.open(`/cgnoticeinfo/${row.id}`)
                }else{
                    this.$warn('请通过审核后查看！')
                }

            }
        },
        formatType: function (row) {
            let text = ''
            noticeType.forEach((item)=>{
                if(item.code == row.noticeType){
                    text = item.name
                }
            })
            return text;
        },
    },
    watch:{
        'activeName':function(val){
            console.log('val')
            this.getPurchaseList()
        },
    }
};
</script>

<style lang="scss">
    .notice-more-wrap{
        width: 100%;
        min-height: 100vh;
        background: #F6F9FD;
        .more-wrap{
            width: 1200px;
            margin: 0 auto;
            .top-logo{
                width: 100%;
                height: 40px;
                padding: 20px 0;
                text-align: left;
                img{
                    height: 40px;
                }
            }
            .top-bg{
                width: 100%;
                height: 200px;
                position: relative;
                overflow: hidden;
                img{
                    width: 100%;
                    margin-top: -50px;
                }
                .input-box{
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: 50px;
                    text-align: center;
                    color: #fff;
                    h3{
                        margin-bottom: 20px;
                        font-size: 24px;
                    }

                }
            }
            .list-box{
                width: calc(100% - 20px);
                min-height: calc(100vh - 360px);
                padding: 10px;
                margin-top: 10px;
                background: #fff;
                padding-bottom: 50px;
                position: relative;
                .show-more-notice{
                    width: 100%;
                    text-align: right;
                    position: absolute;
                    bottom: 10px;
                    right: 0;
                }
            }
        }
        .table-box{
            .el-table{
                &::before{
                    height: 0px;
                }
                tbody{
                    tr{
                        cursor: pointer;
                    }
                }
            }
            .el-table th.el-table__cell.is-leaf, .el-table td.el-table__cell{
                border: none;
            }
        }
    }
</style>
